import { Tooltip as MuiTooltip } from '@mui/material'
import cx from 'classnames'

export const StylableMuiTooltip: typeof MuiTooltip = props => {
  const { className, classes, ...rest } = props

  const propsWithClassnameRelayedToTitle = {
    ...rest,
    classes: {
      ...classes,
      tooltip: cx(classes?.tooltip, className)
    }
  }

  return <MuiTooltip {...propsWithClassnameRelayedToTitle} />
}
